import './prayer-time/prayer-times';
import './print-page/print-page';

import ClipboardJS from "clipboard";

let btn = document.querySelectorAll('.lmt__btn_copy');
new ClipboardJS(btn);

// let page_link = document.location.href;
// let clipboard = new ClipboardJS(btn);

// for (let i = 0; i < btn.length; i++) {
//
//     btn[i].addEventListener('click', () =>{
//         ClipboardJS.copy(document.querySelector('.target-to-copy'));
//     })
// }

// clipboard.on('success', function (e) {
//     console.info('Action:', e.action);
//     console.info('Text:', e.text);
//     console.info('Trigger:', e.trigger);
// });
//
// clipboard.on('error', function (e) {
//     console.info('Action:', e.action);
//     console.info('Text:', e.text);
//     console.info('Trigger:', e.trigger);
// });
